<template>
  <Container
    class="file-list"
    tag="ul"
    lock-axis="y"
    drag-handle-selector=".file__grab"
    drag-class="grabbing"
    :get-child-payload="getDropPayload"
    @drop="dropHandler"
  >
    <Draggable
      class="file-list__item"
      v-for="(file, index) of fileList"
      :key="index"
      tag="li"
    >
      <FileListItem
        :file="file"
        :max-length="maxLengthFileNames"
        :is-disabled="isDisabled"
        @delete-file="() => deleteFile(file, index)"
      />
    </Draggable>
  </Container>
</template>

<script>
import { Container, Draggable } from 'vue-smooth-dnd'
import FileListItem from '@/components/page/files/FileListItem'

const pixel = 410
const addedPx = 160
const letterPx = 8.369

export default {
  name: 'FileList',
  components: {
    Container,
    Draggable,
    FileListItem
  },
  props: {
    fileList: {
      type: [Array, FileList],
      required: true
    },
    isDisabled: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    maxLengthFileNames: 0
  }),
  watch: {
    isDisabled () {
      this.setMaxLengthFileNames()
    }
  },
  mounted () {
    this.setMaxLengthFileNames()
  },
  methods: {
    deleteFile (file, index) {
      this.$emit('delete-file', file, index)
    },
    dropHandler (result) {
      if (result.removedIndex === result.addedIndex) return

      result.removedIndex = this.fileList[result.removedIndex].idx
      result.addedIndex = this.fileList[result.addedIndex].idx

      this.$emit('drop-files', result)
    },
    getDropPayload (idx) {
      return this.fileList[idx]
    },
    setMaxLengthFileNames () {
      let width = this.$el.clientWidth - pixel
      if (this.isDisabled) {
        width += addedPx
      }
      this.maxLengthFileNames = Math.floor(width / letterPx)
    }
  }
}
</script>

<style lang="scss">
.file-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
  min-height: initial;
  padding-right: 10px;
  max-width: initial;
  max-height: calc(6 * 50px + 5 * 4px);
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 7px;
    height: 7px;
  }

  &::-webkit-scrollbar-track {
    border-radius: 30px;
    background-color: #FFFFFF;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 30px;
    background-color: $color_second-light;
  }

  &__item {
    width: 100%;
    border-radius: 3px;
    padding: 5px;
    background-color: #FFFFFF;
  }
}
</style>
